const sampleGroups = [
    {
        key: "common",
        title: "Common Samples",
        items: [
            {
                path: "/samples/opener",
                title: "Opener"
            }   
        ]
    },
    {
        key: "dashboard",
        title: "Dashboard Samples",
        items: [
            {
                path: "/samples/dashboard/stack",
                title: "Stack Sample"
            },
            {
                path: "/samples/dashboard/hsplit",
                title: "HSplit Sample"
            },
            {
                path: "/samples/dashboard/vsplit",
                title: "VSplit Sample"
            }
        ]
    },
    {
        key: "fabric",
        title: "Fabric Samples",
        items: [
            {
                path: "/samples/fabric/form",
                title: "Form Sample"
            },
            {
                path: "/samples/fabric/picker",
                title: "Picker Sample"
            },
            {
                path: "/samples/fabric/personform",
                title: "Person Form (Bound Fields)"
            },
            {
                path: "/samples/fabric/sticky",
                title: "Sticky Sample"
            },
            {
                path: "/samples/fabric/navigationview",
                title: "Navigation View Sample"
            }
        ]
    },
    {
        key: "rmwc-samples",
        title: "RMWC Samples",
        items: [
            {
                path: "/samples/rmwc/card",
                title: "Card Sample"
            },
            {
                path: "/samples/rmwc/gridlist",
                title: "Grid List Sample"
            },
            {
                path: "/samples/rmwc/form",
                title: "Form/Input Sample"
            },
            {
                path: "/samples/rmwc/tabs",
                title: "Tabs Sample"
            },
            {
                path: "/samples/rmwc/toolbar",
                title: "Toolbar Sample"
            }
        ]
    },
    {
        key: "blueprint-samples",
        title: "Blueprint Samples",
        items: [
            {
                path: "/samples/blueprint/alert",
                title: "Alert Sample"
            },
            {
                path: "/samples/blueprint/dialog",
                title: "Dialog Sample"
            },
            {
                path: "/samples/blueprint/contextmenu",
                title: "Context Menu Sample"
            },
            {
                path: "/samples/blueprint/collapse",
                title: "Collapse Sample"
            },
            {
                path: "/samples/blueprint/navbar",
                title: "Navbar Sample"
            },
            {
                path: "/samples/blueprint/tabs",
                title: "Tabs Sample"
            },
            {
                path: "/samples/blueprint/callout",
                title: "Callout Sample"
            },
            {
                path: "/samples/blueprint/collapsibleList",
                title: "Collapsible List Sample"
            },
            {
                path: "/samples/blueprint/slider",
                title: "Slider Sample"
            },
            {
                path: "/samples/blueprint/tagInput",
                title: "Tag Input Sample"
            },
            {
                path: "/samples/blueprint/popover",
                title: "Popover Sample"
            },
            {
                path: "/samples/blueprint/dateInput",
                title: "Date Input Sample"
            },
            {
                path: "/samples/blueprint/table",
                title: "Table Sample"
            }
        ]
    },
    {
        key: "antd-samples",
        title: "Ant Design of React Samples",
        items: [
            {
                path: "/samples/antd/layout",
                title: "Layout Sample"
            },
            {
                path: "/samples/antd/button",
                title: "Button Sample"
            }
        ]
    },
    {
        key: "phosphor-samples",
        title: "Phosphor Samples",
        items: [
            {
                path: "/samples/phosphor/dockpanel",
                title: "Dock Panel"
            }
        ]
    }
];

export { sampleGroups }